export var FETCH_APPEND_PROMO_VISIT = 'FETCH_APPEND_PROMO_VISIT';
export var SUCCESS_FETCH_APPEND_PROMO_VISIT = 'SUCCESS_FETCH_APPEND_PROMO_VISIT';
export var FAILURE_FETCH_APPEND_PROMO_VISIT = 'FAILURE_FETCH_APPEND_PROMO_VISIT';



// WEBPACK FOOTER //
// ./src/actions/promo.js